import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import renderSection2 from './section2';
import renderSection3 from './section3';
import renderSection8 from '../Projection/section8';

import styles from './index.module.scss';

function KFHRus(props) {
    document.title = "КФХ «Русь»";

    return (
    <main className={cn(styles.main, props.className, 'kfhrus')} style={{overflow:"hidden"}}>
      <img className={styles.cover} src={'/assets/d04dbeba7273adaef67d4b54eb9a6792.png'} alt="alt text" />

      <div className={styles.flex_col}>
          {renderSection2(props)}
          {renderSection3(props)}
          {renderSection8(props)}
      </div>
    </main>
  );
}

KFHRus.propTypes = {
  className: PropTypes.string
};

export default KFHRus;
